



















import { Component, Prop } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import { getPeriodOfDay } from "fs-pb-vue2/utilities/index";
import { PersonStore } from "fs-pb-vue2/store/modules/person";
import { ShowcaseVueGB } from "@/extensions/products/ShowcaseVueGB";
import SliderAdaptiv from "@/components/app/SliderAdaptiv.vue";
import { getModule } from "vuex-module-decorators";

@Component({
  components: { BackLink, SliderAdaptiv }
})
export default class ShowCaseTypesList extends ShowcaseVueGB {

  @Prop() pageObj!: any;
  created() {
    window.addEventListener('resize', this.updateAppropriateImage);
  }

  destroyed() {
    window.removeEventListener('resize', this.updateAppropriateImage);
  }

  updateAppropriateImage(): void {
    this.$forceUpdate();
  }

  appropriateImage(item: any): string {
    return window.innerWidth >= 971 ? item.Image : item.ImageMp;
  }

}
